var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"fa-stack"},[_c('i',{staticClass:"fas fa-circle fa-stack-2x"}),_c('i',{staticClass:"fas fa-stack-1x fa-inverse",class:'fa-'+_vm.iconClass})])
}
var staticRenderFns = []

export { render, staticRenderFns }